<template>
  <modal-form v-model="show" size="md">
    <template v-slot:title>
      <h3 class="modal-title">Análise</h3>
    </template>
    <template v-slot:body>
      <v-row v-if="carregando" class="px-3 py-6" justify="center">
        <v-progress-circular indeterminate color="primary" />
      </v-row>

      <v-row v-else class="px-3 py-2">
        <v-col cols="12" class="mb-2">
          <div class="label-title">Decisão:</div>
          <div class="decisao-box" :class="`decisao-box--${decisao.cor}`">
            <v-icon :color="decisao.cor" class="mr-2">{{ decisao.icone }}</v-icon>
            <span :class="`${decisao.cor}--text`">{{ decisao.text }}</span>
          </div>
        </v-col>

        <v-col v-if="mensagemDecisao" cols="12" class="mb-2">
          <div class="label-title">Detalhes da Decisão:</div>
          <div class="content-text">{{ mensagemDecisao }}</div>
        </v-col>
      </v-row>
    </template>
    <template v-slot:actions>
      <div class="flex-grow-1"></div>
      <v-btn color="white" @click="cancelar">Cancelar</v-btn>
    </template>
  </modal-form>
</template>

<script>
export default {
  data() {
    return {
      show: false,
      carregando: false,
      model: {},
      onboardingResumo: {},
      analisesComparativo: []
    }
  },
  computed: {
    decisao() {
      const th = this

      const valor = th.$api.Functions.ObterDecisaoAnalise(
        th.model.situacaoBmpOrigem,
        th.onboardingResumo,
        th.analisesComparativo
      )

      return th.$api.Arrays.DecisaoAnalise.find(x => x.value === valor)
    },
    mensagemDecisao() {
      return this.model.descricaoRetornoBmpOrigem || this.decisao.mensagem
    }
  },
  methods: {
    openModal(curr) {
      const th = this

      th.limparCampos()
      th.show = true
      document.addEventListener('keydown', th.handleKeydown)

      Object.assign(th.model, curr)

      if (th.model.situacaoBmpOrigem === null || th.model.situacaoBmpOrigem === undefined)
        th.obterConsultas()
    },
    obterConsultas() {
      const th = this
      th.carregando = true

      th.$api['analise-onboarding']
        .ObterConsultaCorrentista(th.model.codigo)
        .then(function (response) {
          th.carregando = false

          if (!th.$api.UI.PostLoadData(response)) return

          Object.assign(th.onboardingResumo, response.resumo)
          Object.assign(th.analisesComparativo, response.comparacao)
        })
    },
    limparCampos() {
      const th = this

      th.carregando = false
      th.model = {}
      th.onboardingResumo = {}
      th.analisesComparativo = []
    },
    cancelar() {
      const th = this

      th.limparCampos()
      th.show = false
      th.$emit('close')
      document.removeEventListener('keydown', th.handleKeydown)
    },
    handleKeydown(event) {
      if (event.key === 'Escape') {
        this.cancelar()
      }
    }
  }
}
</script>

<style scoped>
.modal-title {
  font-size: 1.25rem;
  font-weight: bold;
  text-align: center;
}

.label-title {
  font-weight: bold;
  color: #333;
  margin-bottom: 0.25rem;
}

.decisao-box {
  display: flex;
  align-items: center;
  padding: 0.5rem;
  border: 1px solid #ddd;
  border-radius: 5px;
  font-size: 1rem;
  font-weight: bold;
}

.decisao-box--success {
  background-color: #f1f8f2;
  border-color: #c8e6c9;
}

.decisao-box--error {
  background-color: #fdf1f1;
  border-color: #f5c6c6;
}

.decisao-box--warning {
  background-color: #fdf8ee;
  border-color: #f2dfb5;
}

.content-text {
  padding: 0.5rem;
  background-color: #f9f9f9;
  border: 1px solid #ddd;
  border-radius: 5px;
  font-size: 0.95rem;
  color: #555;
}
</style>
